import dom, { Fragment } from "../../dist/jsx-render/dom";
import { ComponentBase } from "./ComponentBase";
import * as ace from "ace-builds/src-noconflict/ace";
//import 'ace-builds/webpack-resolver';
import "ace-builds/src-noconflict/theme-github"
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-css';

type AceEditorComponentProps = {
    field: string;
    model: any;
    isCss: boolean;
    isJson?: boolean;
    changeEvent?: (event: Event) => void;
}


export class AceEditorComponent extends ComponentBase {
    props: AceEditorComponentProps;
    private editor: any;

    constructor(props: AceEditorComponentProps) {
        super(props);
    }

    element: HTMLElement = <div className="codejar-editor editor"></div>;

    render() {
        this.editor = ace.edit(this.element);
        this.editor.setTheme("ace/theme/github");
        if (this.props.isCss) {
            this.editor.session.setMode("ace/mode/css");
        } else if (this.props.isJson) {
            this.editor.session.setMode("ace/mode/json");
        } else {
            this.editor.session.setMode("ace/mode/html");
        }

        this.editor.setValue(this.props.model[this.props.field] ? this.props.model[this.props.field] : "");

        this.editor.getSession().on('change', () => {
            this.props.model[this.props.field] = this.editor.getValue();
        });

        return this.element;
    }

    getEditor = () => {
        return this.editor;
    }

    dispose() { }

    validate() { }
}